<div class="not-found-section">
    <div class="col-md-12 not-found-body">
        <img src="assets/img/logo/not-found.gif" alt="">
        <h4>Coming Soon!</h4>
        <p>{{comingSoonMsg}}</p>

    </div>
</div>